import { ISummary } from '../models/Object'
import fulfillment from '../assets/icons/fulfillment.png'
import checkin from '../assets/icons/checkin.png'
import checkout from '../assets/icons/checkout.png'
import boarding from '../assets/icons/boarding.png'
import { imageCacheService } from './images/imageCache'

export default function drawSummaryIcons(
  ctx: CanvasRenderingContext2D,
  constants,
  summarySettings: ISummary,
) {
  const { imageCache } = imageCacheService
  const iconsCount =
    +summarySettings.feeding +
    +summarySettings.fulfillment +
    +summarySettings.checkinout * 2

  const y = Math.round(
    (constants.SUMMARY_HEIGHT - iconsCount * constants.SUMMARY_ICON_SIZE) / 2,
  )
  const x = Math.round(
    constants.GRID_WIDTH / 2 -
      constants.GRID_BORDER_WIDTH -
      constants.SUMMARY_ICON_SIZE,
  )
  let position = 0

  const drawIcon = position => img =>
    ctx.drawImage(
      img,
      x,
      y + position * constants.SUMMARY_ICON_SIZE,
      constants.SUMMARY_ICON_SIZE,
      constants.SUMMARY_ICON_SIZE,
    )

  if (summarySettings.fulfillment) {
    imageCache(fulfillment)(drawIcon(position))
    position++
  }
  if (summarySettings.feeding) {
    imageCache(boarding)(drawIcon(position))
    position++
  }
  if (summarySettings.checkinout) {
    imageCache(checkin)(drawIcon(position))
    position++
    imageCache(checkout)(drawIcon(position))
  }
}
